<template>
    <div>
        <transition name="fade" mode="out-in">
            <loader v-if="loading"></loader>
            <div v-else>
                <div class="modal-content wide">
                    <div v-html="termsAndConditions"></div>
                    <div class="modal-card-foot">
                        <div class="level">
                            <div class="level-left">&nbsp;</div>
                            <div class="level-right">
                                <button
                                    @click="$router.go(-1)"
                                    class="btn primary"
                                    v-t="`${langRoot}.returnBtn`"
                                ></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
const name = 'terms-conditions';

import { mapActions, mapGetters } from 'vuex';
import Loader from '@shared/components/Loader';
import loading from '@shared/mixins/loading';

export default {
    name,
    componentName: name,
    mixins: [loading],
    components: {
        [Loader.name]: Loader,
    },
    data() {
        return {
            termsAndConditions: '',
            langRoot: 'footer',
        };
    },
    methods: {
        ...mapActions('tandcs', ['loadtandcs']),
        ...mapGetters('tandcs', ['getStatictandcs']),
    },

    created() {
        this.startLoading();
        this.loadtandcs()
            .then((_) => {
                this.termsAndConditions = this.getStatictandcs();
            })
            .catch((e) => {
                this.$router.replace({
                    name: 'error',
                    params: {
                        code: e.response.status,
                    },
                });
            })
            .finally(this.stopLoading);
    },
};
</script>




// WEBPACK FOOTER //
// shared/components/TermsConditions.vue